import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import SerialNumber from './SerialNumberDialog.form';
import SerialNumberBinTracked from './SerialNumberBinDialog.form';
import { ISerialNumberDialogProperties } from './SerialNumberDialog.properties';

const SerialNumberDialog = (props: ISerialNumberDialogProperties): JSX.Element => {
    const { open, onCancel, isBinTracked, productId, warehouseId, defaultBin, calculateSerialNumberHandler } = props;
    const formSchema = SerialNumber.SerialNumberForm;
    const formSchemaBinTracked = SerialNumberBinTracked.SerialNumberForm;

    const [serialNumberBinTracked, setSerialNumberBinTracked] = React.useState({
        LotSerial: null,
        Quantity: 1,
        Bin: defaultBin,
        SaveLocation: false
    });

    const [serialNumber, setSerialNumber] = React.useState({
        LotSerial: null,
        Quantity: 1,
    });

    const okHandler = () => {
        calculateSerialNumberHandler(isBinTracked ? serialNumberBinTracked : serialNumber);
    };

    const isOkEnable = serialNumber?.LotSerial && serialNumber?.Quantity;
    const isOkEnableBinTracked = serialNumberBinTracked?.LotSerial && serialNumberBinTracked?.Quantity && serialNumberBinTracked?.Bin;

    const getActions = () => {
        return [
            {
                title: 'Ok',
                iconName: 'CheckCircle',
                isDefault: true,
                disabled: isBinTracked ? !isOkEnableBinTracked : !isOkEnable,
                listener: async () => {
                    okHandler();
                }
            },
            {
                title: 'Cancel',
                iconName: 'Cancel',
                listener: () => {
                    if (onCancel) {
                        onCancel();
                    }
                },
            },
        ];
    };

    return (
        <div>
            <FormViewModal
                open={open}
                loading={false}
                title='Enter Serial Number Range'
                formProps={{
                    style: {
                        width: 500,
                    },
                    formSchema: isBinTracked ? formSchemaBinTracked : formSchema,
                    productId: productId,
                    warehouse: warehouseId,
                    initialValues: isBinTracked ? serialNumberBinTracked : serialNumber,
                    valuesSchema: isBinTracked ? serialNumberBinTracked : serialNumber,
                    fieldExtensions: ({
                        LotSerial: {
                            onChange: (event) => {
                                const { value } = event?.target || {};
                                isBinTracked ?
                                    setSerialNumberBinTracked({
                                        ...serialNumberBinTracked, LotSerial: value
                                    }) : setSerialNumber({
                                        ...serialNumber, LotSerial: value
                                    });
                            }
                        },
                        Quantity: {
                            onChange: (event) => {
                                const { value } = event?.target || {};
                                isBinTracked ?
                                    setSerialNumberBinTracked({
                                        ...serialNumberBinTracked, Quantity: value
                                    }) : setSerialNumber({
                                        ...serialNumber, Quantity: value
                                    });
                            }
                        },
                        Bin: {
                            onSelectedItemChange: (value) => {
                                setSerialNumberBinTracked({
                                    ...serialNumberBinTracked, Bin: value?.Code
                                });
                            }
                        },
                        SaveLocation: {
                            onChange: (event) => {
                                const { checked } = event?.target || {};
                                setSerialNumberBinTracked({
                                    ...serialNumberBinTracked, SaveLocation: checked
                                });
                            }
                        }
                    })
                }}
                actions={getActions()}
                dialogActionsButtons={true}
                dialogActionsShadow={false}
            />
        </div>
    );
};
export default SerialNumberDialog;
